import React from 'react';

const UnsupportedPreview = ({ filename, fileType }) => {
  const getFileIcon = (type) => {
    const icons = {
      video: "M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z",
      audio: "M15.536 8.464a5 5 0 010 7.072m2.828-9.9a9 9 0 010 12.728M9 12a1 1 0 01-.117-.993l.117-.007h2a1 1 0 01.993.883L12 12v6a3 3 0 01-2.824 2.995L9 21a3 3 0 01-2.995-2.824L6 18v-6a1 1 0 01.883-.993L7 11h2z",
      archive: "M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10",
      default: "M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
    };
    return icons[type] || icons.default;
  };

  return (
    <div className="bg-gray-100 rounded-lg p-8 text-center min-h-96 flex items-center justify-center">
      <div className="text-gray-500">
        <svg className="w-16 h-16 mx-auto mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d={getFileIcon(fileType)} />
        </svg>
        <p className="text-lg font-medium">Preview not available</p>
        <p className="text-sm mt-2">
          {filename.split('.').pop().toUpperCase()} files cannot be previewed
        </p>
        <p className="text-xs mt-2 text-gray-400">
          Download the file to view its contents
        </p>
      </div>
    </div>
  );
};

export default UnsupportedPreview;